module.exports = __webpack_public_path__ + "static/js/2.636a71b1.chunk.worker.js"